export const SelectField: React.FC<{
    name: string;
    value: string;
    onChange: (e: React.ChangeEvent<HTMLSelectElement>) => void;
    onBlur?: (e: React.FocusEvent<HTMLSelectElement>) => void;
    error?: string;
    touched?: boolean;
    options: { value: string; label: string }[];
    placeholder?: string;
    disabled?: boolean;
  }> = ({
    name,
    value,
    onChange,
    onBlur,
    error,
    touched,
    options,
    placeholder = 'Select an option',
    disabled = false
  }) => {
    const hasError = error && touched;
    
    return (
      <select
        className={`input-field ${hasError ? 'input-error' : ''}`}
        name={name}
        value={value}
        onChange={onChange}
        onBlur={onBlur}
        disabled={disabled}
      >
        <option value="">{placeholder}</option>
        {options.map((option) => (
          <option key={option.value} value={option.value}>
            {option.label}
          </option>
        ))}
      </select>
    );
  };